import { render, staticRenderFns } from "./Thana.vue?vue&type=template&id=4a4d9e6f&"
import script from "./Thana.vue?vue&type=script&lang=js&"
export * from "./Thana.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports